module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 20 20"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "Слой_2",
      "data-name": "Слой 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Слой_1-2",
      "data-name": "Слой 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M10,20A10,10,0,1,1,20,10,10,10,0,0,1,10,20ZM10,1.33A8.67,8.67,0,1,0,18.67,10,8.68,8.68,0,0,0,10,1.33Z"
    }
  }), _c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M13,11.39c-.41,0-.81,0-1.22,0s-.38.07-.38.37c0,.83,0,1.66,0,2.49,0,.42-.16.57-.57.55-.59,0-1.17,0-1.75,0-.34,0-.48-.14-.48-.47,0-.86,0-1.72,0-2.58,0-.3-.09-.35-.37-.34-.85,0-1.69,0-2.54,0-.29,0-.48-.1-.48-.42,0-.61,0-1.22,0-1.84,0-.33.12-.53.52-.52.84,0,1.69,0,2.53,0,.28,0,.38-.07.37-.36,0-.84,0-1.69,0-2.53,0-.35.11-.52.48-.52h1.83c.34,0,.48.16.47.48,0,.83,0,1.66,0,2.49,0,.34.07.46.43.45.82,0,1.63,0,2.45,0,.41,0,.56.18.55.55,0,.6,0,1.19,0,1.79,0,.3-.13.46-.46.45s-.9,0-1.35,0Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c94d94e4","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIcon/iconsTemplate/contents/addANote.vue
// module id = 49607c5d1a600c6bf567
// module chunks = 89